import I18n from 'I18n';
import ApiOutagePlaceholder from 'in-meeting-experience-ui-components/components/common/ApiOutagePlaceholder/ApiOutagePlaceholder';
import { ErrorContext } from 'in-meeting-experience-ui-components/contexts/error/context';
import { useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ApiOutageWrapper = ({
  children
}) => {
  const {
    isApiOutage
  } = useContext(ErrorContext);
  if (isApiOutage) {
    return /*#__PURE__*/_jsx(ApiOutagePlaceholder, {
      title: I18n.text('errors.generalHubSpotApiErrorTitle'),
      description: I18n.text('errors.generalHubSpotApiErrorDescription')
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default ApiOutageWrapper;